import LoginForm from "@/features/identity/components/LoginForm";
import IdentityPageLayout from "@/features/identity/components/IdentityPageLayout";

const LoginPage = () => {
    return (
        <IdentityPageLayout>
            <LoginForm />
        </IdentityPageLayout>
    );
};

export default LoginPage;
